'use client';

import type { ComponentRef, ReactNode } from 'react';
import { forwardRef } from 'react';
import { MenuGroup, MenuTextField, useDebounceCallback } from '@frameio/vapor';
import { IconMagnifyingglass } from '@frameio/vapor-icons';

export type SearchMenuItemsProps = {
  children: ReactNode;
  debounceMs?: number;
  className?: string;
  isSearchVisible: boolean;
  label?: string;
  maxHeight?: string;
  onRequestSearch: (query: string) => void;
  placeholder: string;
};

export const SearchMenuItems = forwardRef<
  ComponentRef<typeof MenuTextField>,
  SearchMenuItemsProps
>(
  (
    {
      children,
      className,
      debounceMs = 200,
      isSearchVisible,
      label,
      maxHeight = '365px',
      onRequestSearch,
      placeholder,
    },
    forwardedRef
  ) => {
    const [debouncedSearch] = useDebounceCallback(onRequestSearch, debounceMs);

    return (
      <>
        {isSearchVisible && (
          <MenuGroup label={label}>
            <MenuTextField
              ref={forwardedRef}
              adornmentBefore={<IconMagnifyingglass />}
              onChange={(event) => debouncedSearch(event.target.value)}
              placeholder={placeholder}
              role="searchbox"
            />
          </MenuGroup>
        )}

        <MenuGroup
          className={className}
          label={!isSearchVisible && label}
          maxHeight={maxHeight}
        >
          {children}
        </MenuGroup>
      </>
    );
  }
);
